import { render, staticRenderFns } from "./CommercialDetails.vue?vue&type=template&id=55086931&"
import script from "./CommercialDetails.vue?vue&type=script&lang=js&"
export * from "./CommercialDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports